import { useGetMyAllProjectTimeSummariesForListLazyQuery } from "@repo/server-api";
import { useNotification } from "@repo/shared/components";
import dayjs from "dayjs";
import { useCallback, useState } from "react";

import type { DataSource } from "@repo/legacy/components/shared/lists/DataSource";
import type { ProjectTimeSummary } from "@repo/shared-project/types/ProjectTypes";

export function useAllProjectTimeSummaryDataSource(): DataSource<ProjectTimeSummary> {
	const { showNotification } = useNotification();
	const [rows, setRows] = useState<ProjectTimeSummary[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [filter, setFilter] = useState({
		year: dayjs().format("YYYY-MM-DD"),
		showDeleted: false,
	});

	const mapProjectNodeToSummary = (node: {
		totalWorkedMinutes: number;
		totalMinutes: number;
		positionName: string;
		projectName: string;
		projectId: string;
		projectPositionId: string;
	}): ProjectTimeSummary => {
		return {
			id: node.projectId + "-" + node.projectPositionId,
			projectName: node.projectName,
			positionName: node.positionName,
			totalMinutes: node.totalMinutes,
			workedMinutes: node.totalWorkedMinutes,
		};
	};

	const [getProjectTimeSummaries] = useGetMyAllProjectTimeSummariesForListLazyQuery({
		fetchPolicy: "no-cache",
		onError(error: { message: string }) {
			showNotification(error.message, "error");
			setIsLoading(false);
		},
	});

	const fetchProjectSummaryData = useCallback(() => {
		setIsLoading(true);
		getProjectTimeSummaries({
			variables: {
				startDate: dayjs(filter.year).startOf("year").format("YYYY-MM-DD"),
				endDate: dayjs(filter.year).endOf("year").format("YYYY-MM-DD"),
				showDeleted: filter.showDeleted,
			},
		}).then((response) => {
			if (response.data?.myAllProjectTimeSummaries) {
				let tmp = response.data.myAllProjectTimeSummaries.map((node) =>
					mapProjectNodeToSummary(node),
				);

				setRows(tmp);
				setIsLoading(false);
			}
		});
	}, [filter]);

	return {
		rows,
		isLoading,
		setIsLoading,
		fetchProjectSummaryData,
		setFilter,
		filter,
	};
}
